import { styled } from '@linaria/react'

export const Wrapper = styled.div`
  position: relative;
  display: block;
  width: 100%;
  color: ${props => props.textColor || 'var(--black)'};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    width: 100vw;
    height: 100%;
    background: ${props => props.bgColor || 'var(--white)'};
    transform: translateX(-50vw);
    z-index: 1;
  }
`

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: ${props =>
    props.isWide ? 'var( --wide-size )' : 'var( --content-size )'};
  padding: ${props => (props.padding ? props.padding : 0)};
  margin-inline: auto;
  z-index: 2;

  @media (max-width: 1023.98px) {
    padding: ${props =>
      props.mobilePadding ? props.mobilePadding : props.padding};
  }

  @media (max-width: 767.98px) {
    padding: ${props =>
      props.mobilePadding ? props.mobilePadding : props.padding};
  }
`

export const Row = styled.div`
  display: ${props => props.display || 'flex'};
  align-items: ${props => props.alignItems || 'inherit'};
  flex-direction: ${props => props.direction || 'row'};
  gap: ${props => props.gap || '2rem'};
  height: 100%;

  @media (max-width: 1023.98px) {
    flex-direction: ${props => props.tabletDirection || 'row'};
  }

  @media (max-width: 767.98px) {
    flex-direction: ${props => props.mobileDirection || 'column'};
  }
`

export const Rownogap = styled.div`
  display: ${props => props.display || 'flex'};
  align-items: ${props => props.alignItems || 'inherit'};
  flex-direction: ${props => props.direction || 'row'};
  gap: 0;
  height: 100%;

  @media (max-width: 1023.98px) {
    flex-direction: ${props => props.tabletDirection || 'row'};
  }

  @media (max-width: 767.98px) {
    flex-direction: ${props => props.mobileDirection || 'column'};
  }
`

export const Col = styled.div`
  flex: ${props => props.size || '1'};
  width: ${props => (props.half ? '50%' : '100%')};
  background-color: ${props => (props.bgColor ? props.bgColor : 'inherit')};
  color: ${props => (props.textColor ? props.textColor : 'inherit')};

  @media (max-width: 1023.98px) {
    &.hide-md-down {
      display: none;
    }
  }

  @media (max-width: 767.98px) {
    order: ${props => (props.mobileOrder ? props.mobileOrder : 1)};
    width: 100%;
  }
`
